import { cn } from "@/lib/utils";
import { t } from "@shared/i18n";

const COLORS = ["", "bg-slate/40", "bg-slate", "bg-brand", "bg-[#f08a24]", "bg-accent"];
export const PRIORITY_LABELS = ["", t("Très basse"), t("Basse"), t("Normale"), t("Haute"), t("Critique")];

export function PriorityDot({ priority, className }: { priority: number; className?: string }) {
  return <span title={t("Priorité {0} — {1}", priority, PRIORITY_LABELS[priority])} className={cn("inline-block size-2 shrink-0 rounded-full", COLORS[priority] ?? "bg-slate", className)} />;
}

export function PriorityPicker({ value, onChange }: { value: number; onChange: (v: number) => void }) {
  return (
    <div className="flex gap-1" role="radiogroup" aria-label={t("Priorité")}>
      {[1, 2, 3, 4, 5].map((p) => (
        <button
          key={p}
          type="button"
          role="radio"
          aria-checked={value === p}
          title={PRIORITY_LABELS[p]}
          onClick={() => onChange(p)}
          className={cn("flex h-9 flex-1 items-center justify-center gap-1.5 rounded-lg border text-sm", value === p ? "border-brand bg-primary-soft font-medium" : "border-border text-muted hover:border-border-strong")}
        >
          <PriorityDot priority={p} /> {p}
        </button>
      ))}
    </div>
  );
}
